import { Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatCheckbox, MatCheckboxDefaultOptions, MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { IUser } from '@shared/models/iuser.model';
import { isUserActive } from '@shared/utils/helpers/add-to-contacts.helpers';
import { v4 as uuidV4 } from 'uuid';

const colors = [
  '#00b2dd',
  '#ec008c',
  '#a23f97',
  '#f58220',
  '#ffdd00',
  '#69be2b',
  '#004b35',
  '#00a657',
  '#bfd857',
  '#00b5db',
  '#d0021b',
];
@Component({
  selector: 'miq-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
  providers: [
    { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions },
  ],
  standalone: false,
})
export class ContactCardComponent implements OnDestroy {
  @ViewChild(MatCheckbox, { static: true })
  private checkbox: MatCheckbox;
  @Input()
  public user: IUser;
  @Input()
  public companyId: number;
  @Input()
  public selected: boolean;
  @Input()
  public isOnMIQ: boolean;

  @Output()
  public change: EventEmitter<{ checked: boolean; user: IUser }> = new EventEmitter();

  public color: string;
  public isActiveUser: boolean;

  constructor() {
    // Security: use uuidV4 as entropy source instead of Math.random()
    const uuidHex = uuidV4().replace(/-/g, '').slice(0, 8);
    this.color = colors[(parseInt(uuidHex, 16) >>> 0) % colors.length];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.user && changes.user.currentValue && this.companyId) {
      this.isActiveUser = isUserActive(changes.user.currentValue, this.companyId);
    }
  }

  onClick() {
    this.checkbox.toggle();
    this.change.emit({ checked: this.checkbox.checked, user: this.user });
  }

  ngOnDestroy() {
    this.checkbox = null;
  }
}
